import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/apiConfig';
import { useUser } from '../contexts/UserContext';

const ROLES = [
  { value: 'admin', label: 'Administrador' },
  { value: 'moderador', label: 'Moderador' },
  { value: 'usuario', label: 'Usuario' }
];

const RolPruebaSelector = () => {
  const { user, checkAuth } = useUser();
  const [isChanging, setIsChanging] = useState(false);
  const [error, setError] = useState('');

  const handleChange = async (event) => {
    setError('');
    setIsChanging(true);

    try {
      await axios.post(`${API_BASE_URL}/cambiar_rol_prueba.php`, { rol: event.target.value });
      await checkAuth({ keepUserOnFailure: true });
    } catch (changeError) {
      setError(changeError?.response?.data?.message || 'No se pudo cambiar la vista.');
    } finally {
      setIsChanging(false);
    }
  };

  return (
    <div className="flex flex-col gap-1 sm:items-end">
      <div className="flex items-center gap-2">
        <label htmlFor="rol-prueba" className="whitespace-nowrap text-sm font-semibold text-violet-900 dark:text-violet-100">
          Ver como
        </label>
        <select
          id="rol-prueba"
          value={user.rol}
          onChange={handleChange}
          disabled={isChanging}
          title="Cuenta de prueba: se ve todo como este rol, pero solo puedes cambiar tu foto de perfil. Como usuario puedes jugar el concurso diario, sin aparecer en ningún ranking."
          className="rounded-md border border-violet-300 bg-white p-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-violet-500 disabled:opacity-60 dark:border-violet-600 dark:bg-gray-800 dark:text-white"
        >
          {ROLES.map(({ value, label }) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      </div>
      {error && <p className="text-xs text-red-600 dark:text-red-300">{error}</p>}
    </div>
  );
};

export default RolPruebaSelector;
